import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import Login from './Login';
import ProfileChoice from './components/login/ProfileChoice';
import Dashboard from './Dashboard';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log('Auth state changed, user:', currentUser);
      setUser(currentUser);
      setSelectedProfile(null);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const handleProfileSelect = (profile) => {
    console.log('Profile selected:', profile);
    setSelectedProfile(profile);
  };

  const handleChangeProfile = () => {
    setSelectedProfile(null);
  };

  console.log('App render - user:', user, 'selectedProfile:', selectedProfile, 'loading:', loading);

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '100px' }}>Loading...</div>;
  }

  // Not logged in → Show Login
  if (!user) {
    console.log('Showing Login');
    return <Login onLoginSuccess={() => {}} />;
  }

  // Logged in but no profile selected → Show ProfileChoice
  if (!selectedProfile) {
    console.log('Showing ProfileChoice');
    return <ProfileChoice onProfileSelect={handleProfileSelect} />;
  }

  // Logged in AND profile selected → Show Dashboard
  console.log('Showing Dashboard');
  return <Dashboard selectedProfile={selectedProfile} onChangeProfile={handleChangeProfile} />;
}

export default App;